// src/App.js
import React from "react"; // Added useEffect
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import EnglishPracticePage from "./pages/EnglishPracticePage";
import UserDashboardPage from "./pages/UserDashboardPage";
import InterviewHistoryPage from "./pages/InterviewHistoryPage";
import EnglishPracticeHistoryPage from "./pages/EnglishPracticeHistoryPage";
import InterviewSessionDetailPage from "./pages/interview/InterviewSessionDetailPage"; // Adjust path
import EnglishPracticeSessionDetailPage from "./pages/EnglishPracticeSessionDetailPage";
// New Interview Pages
import InterviewSetupPage from "./pages/interview/InterviewSetupPage";
import InterviewActivePage from "./pages/interview/InterviewActivePage";
import InterviewSummaryPage from "./pages/interview/InterviewSummaryPage";
import CookieNotice from "./components/CookieNotice";
import Footer from "./components/Footer";

// Auth related imports
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ResendVerificationPage from "./pages/ResendVerificationPage"; // Import ResendVerificationPage
import ConfirmEmailPage from "./pages/ConfirmEmailPage";
import PricingPage from "./pages/PricingPage"; // Import PricingPage
import AuthGuard from "./components/AuthGuard";
import UnauthGuard from "./components/UnauthGuard"; // Optional

import { AuthProvider } from "./contexts/AuthContext"; // Import AuthProvider

import useAuth from "./hooks/useAuth";

import "./App.css";
import "./index.css";
function AppContent() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const onGoHome = () => {
    navigate("/dashboard");
  };
  return (
    <>
      <Navbar />
      <main className="mx-auto min-h-[calc(100vh-theme(spacing.16))]">
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              isAuthenticated ? <Navigate to="/dashboard" /> : <HomePage />
            }
          />
          <Route
            path="/dashboard"
            element={
              <AuthGuard>
                <UserDashboardPage />
              </AuthGuard>
            }
          />
          <Route
            path="/dashboard/interview-history"
            element={
              <AuthGuard>
                <InterviewHistoryPage />
              </AuthGuard>
            }
          />
          <Route
            path="/dashboard/english-history"
            element={
              <AuthGuard>
                <EnglishPracticeHistoryPage />
              </AuthGuard>
            }
          />
          <Route path="/pricing" element={<PricingPage />} />{" "}
          {/* Pricing Page Route */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route
            path="/account/confirm-email"
            element={<ConfirmEmailPage />}
          />{" "}
          {/* Confirm Email Route */}
          {/* Routes for unauthenticated users (e.g., login, register) */}
          <Route
            path="/login"
            element={
              <UnauthGuard>
                <LoginPage />
              </UnauthGuard>
            }
          />
          <Route
            path="/register"
            element={
              <UnauthGuard>
                <RegisterPage />
              </UnauthGuard>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <UnauthGuard>
                <ForgotPasswordPage />
              </UnauthGuard>
            }
          />
          <Route
            path="/account/reset-password"
            element={
              <UnauthGuard>
                <ResetPasswordPage />
              </UnauthGuard>
            }
          />
          <Route
            path="/account/resend-verification"
            element={
              <UnauthGuard>
                <ResendVerificationPage />
              </UnauthGuard>
            }
          />
          {/* Protected Routes */}
          {/* <Route
            path="/interview"
            element={
              <AuthGuard>
                <InterviewPage />
              </AuthGuard>
            }
          /> */}
          <Route
            path="/interview"
            element={<Navigate to="/interview/setup" replace />}
          />
          <Route
            path="/interview/setup"
            element={
              <AuthGuard>
                <InterviewSetupPage />
              </AuthGuard>
            }
          />
          <Route
            path="/interview/active"
            element={
              <AuthGuard>
                <InterviewActivePage />
              </AuthGuard>
            }
          />
          <Route
            path="/interview/summary"
            element={
              <AuthGuard>
                <InterviewSummaryPage onGoHome={onGoHome} />
              </AuthGuard>
            }
          />
          <Route
            path="/interview/history/:sessionId"
            element={
              <AuthGuard>
                <InterviewSessionDetailPage />
              </AuthGuard>
            }
          />
          <Route
            path="/english-practice"
            element={
              <AuthGuard>
                <EnglishPracticePage />
              </AuthGuard>
            }
          />
          <Route
            path="/dashboard/english-history/:sessionId"
            element={
              <AuthGuard>
                <EnglishPracticeSessionDetailPage />
              </AuthGuard>
            }
          />
          {/* Fallback Route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <CookieNotice />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        {" "}
        {/* Wrap your app with AuthProvider */}
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
